import React, {PropTypes} from 'react';
import { MenuItem } from 'material-ui';
import RaisedButton from 'material-ui/RaisedButton';
import {Field, reduxForm} from 'redux-form';
import IntlPolyfill from 'intl';
import 'intl/locale-data/jsonp/fr';
import {connect} from 'react-redux';
import moment from 'moment';

import {
    DatePicker,
    TextField,
    SelectField
} from 'redux-form-material-ui';


const DateTimeFormat = IntlPolyfill.DateTimeFormat;

let EditProjectForm = ({handleSubmit, pristine, reset, submitting, errors, projectStates}) => {
    const projectStatesList = projectStates.map(state => (
        <MenuItem key={state.id} value={state.id} primaryText={state.name}/>));
    return (
        <div style={{padding: 10, width: '100%'}}>
            <form onSubmit={handleSubmit} autoComplete="false">
                <Field
                    name="name"
                    component={TextField}
                    hintText="Nom"
                    floatingLabelFixed
                    floatingLabelText="Nom"
                    errorText={errors && errors.name && errors.name[0]}
                    style={{width: '100%'}}/>
                <Field
                    name="state"
                    component={SelectField}
                    hintText="Statut"
                    floatingLabelFixed
                    floatingLabelText="Statut"
                    errorText={errors && errors.state && errors.state[0]}
                    style={{width: '100%'}}>
                    {projectStatesList}
                </Field>
                <Field
                    name="note"
                    component={TextField}
                    hintText="Notes"
                    floatingLabelFixed
                    floatingLabelText="Notes"
                    style={{width: '100%'}}
                    multiLine
                    rows={2}/>
                <Field name="preview_date"
                       value={null}
                       component={DatePicker}
                       DateTimeFormat={DateTimeFormat}
                       hintText="Date de la preview"
                       floatingLabelFixed
                       floatingLabelText="Date de la preview"
                       format={null} locale="fr"/>
                <Field name="deploy_date"
                       value={null}
                       component={DatePicker}
                       DateTimeFormat={DateTimeFormat}
                       hintText="Date de la MEL"
                       floatingLabelFixed
                       floatingLabelText="Date de la MEL"
                       format={null} locale="fr"/>
                <Field component={TextField} name="id" style={{display:'none'}} />
                <div style={{display: 'inline-block', width: '100%', position: 'relative'}}>
                    <RaisedButton type="submit" label="Mettre à jour" primary disabled={pristine || submitting}/> &nbsp;
                    <RaisedButton label="Réinitiliser" secondary disabled={pristine || submitting} onClick={reset}/>
                </div>
            </form>
        </div>
    );
};

EditProjectForm.propTypes = {
    projectStates: PropTypes.array,
    errors: PropTypes.array,
    reset: PropTypes.func,
    pristine: PropTypes.bool,
    handleSubmit: PropTypes.func,
    submitting: PropTypes.bool
};

EditProjectForm = reduxForm({form: 'editProjectForm'})(EditProjectForm);

EditProjectForm = connect(
    (state) => ({
        initialValues: {
            id: state.projectContainer.project.id,
            name: state.projectContainer.project.name,
            state: state.projectContainer.project.state.id,
            note: state.projectContainer.project.note,
            preview_date: (state.projectContainer.project.preview_date != null) ? moment(state.projectContainer.project.preview_date).toDate() : null,
            deploy_date: (state.projectContainer.project.deploy_date != null) ? moment(state.projectContainer.project.deploy_date).toDate() : null
        }
    })
)(EditProjectForm);

export default EditProjectForm;


/** WEBPACK FOOTER **
 ** ./src/components/ProjectManager/EditProjectForm.js
 **/